if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      document.addEventListener("DOMContentLoaded", this.setInitState);
      this.cartTermsCheckbox.addEventListener('change', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      const wrapper = this.cartTermsCheckbox.closest('cart-terms');
      const submitButton = document.querySelector('cart-drawer button[form="cart-drawer-form"][type="submit"]');
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        if(!wrapper.querySelector('.cart_term_error')){
          let cart_term_error = document.createElement('p');
          cart_term_error.textContent = theme.strings.cartTermsConfirmation;
          cart_term_error.classList.add('cart_term_error', 'flex-auto', 'text-center', 'mt-2', 'text-sm', 'text-red');
          wrapper.appendChild(cart_term_error);
        }
        submitButton.disabled = true;
        return;
      }
      if(wrapper.querySelector('.cart_term_error')){
          wrapper.querySelector('.cart_term_error').remove();
      }
      submitButton.disabled = false;
    }
    setInitState(){
      const submitButton = document.querySelector('cart-drawer button[form="cart-drawer-form"][type="submit"]');
      submitButton.disabled = true;
    }
  }
  customElements.define('cart-terms', CartTerms);
}
